<template>
  <v-container>
    <MessagePopup :text="errorMessage" color="error"/>
    <h1>Console {{ supplier.name }}</h1>
    <div v-if="isSupplierCapableOf({ connectorName: this.supplier.connector, capability: 'searchArticle' })">
      <h2>Request search for raw results</h2>
      <p>
        Curious to see the raw responses from the APIs? Fill the form below and request it.
      </p>
      <v-container>
        <v-row>
          <v-col cols="12" sm="8" md="4" class="pt-2">
            <v-text-field
              label="Part number"
              v-model="query"
              @keyup.enter="requestSearchRaw"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="pt-2">
            <v-switch
              label="Exact match"
              v-model="exact"
            ></v-switch>
          </v-col>
          <v-col cols="4" sm="3" md="2">
            <v-btn @click="requestSearchRaw" :loading="loading" class="mr-4">
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <JSONView v-if="responseSearch" rootKey="response" :data="responseSearch"/>
    <div v-if="isSupplierCapableOf({ connectorName: this.supplier.connector, capability: 'supplyChain' })">
      <h2>Request Supply Chain Programs for raw results</h2>
      <p>
        This return raw results of SCP, filtered to customer ID location if specified, else all locations.
      </p>
      <v-container>
        <v-row>
          <v-col cols="12" sm="8" md="4" class="pt-2">
            <v-text-field
              label="Location"
              v-model="location"
              @keyup.enter="requestRaw"
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="3" md="2">
            <v-btn @click="requestSCPRaw" :loading="loading" class="mr-4">
              Fetch
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <JSONView v-if="responseSCP" rootKey="response" :data="responseSCP"/>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { JSONView } from 'vue-json-component'
import MessagePopup from '@/components/MessagePopup.vue'

export default {
  data: () => ({
    supplier: null,
    query: 'NE555DR',
    exact: true,
    loading: false,
    errorMessage: '',
    responseSearch: null,
    location: '',
    responseSCP: null
  }),
  components: {
    JSONView,
    MessagePopup
  },
  computed: {
    ...mapState(['suppliers']),
    ...mapGetters(['isSupplierCapableOf'])
  },
  created () {
    this.supplier = this.suppliers.filter(item => item.id === this.$route.params.id)[0]
    if (this.supplier.connector === 'Digi-Key API') {
      this.location = this.supplier.parameters.customerId
    }
  },
  methods: {
    requestSearchRaw () {
      this.loading = true
      this.responseSearch = null
      this.$http(`${this.supplier['@id']}/articles/search`, {
        params: {
          query: this.query,
          exact: this.exact,
          raw: true
        }
      })
        .then(response => {
          if (response.status === 200) {
            this.responseSearch = response.data['hydra:member'][0]
          }
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    requestSCPRaw () {
      this.loading = true
      this.responseSCP = null
      this.$http(`${this.supplier['@id']}/scp`, {
        params: {
          location: this.location,
          raw: true
        }
      })
        .then(response => {
          if (response.status === 200) {
            this.responseSCP = response.data.response
          }
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
